import { render, staticRenderFns } from "./wareProduct.vue?vue&type=template&id=07fe5097&scoped=true&"
import script from "./wareProduct.vue?vue&type=script&lang=js&"
export * from "./wareProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe5097",
  null
  
)

export default component.exports